'use client';

import React from 'react';
export const ThemeBoundaryContext = /*#__PURE__*/React.createContext({
  theme: null
});
/** @experimental */
export const ThemeBoundary = ({
  theme,
  children
}) => /*#__PURE__*/React.createElement(ThemeBoundaryContext.Provider, {
  value: {
    theme
  }
}, children);